import { AbstractControl, ValidationErrors } from '@angular/forms';

export function validateZipCode(c: AbstractControl): ValidationErrors | null {
    let ZIP_REGEX = /^\d{5}(-?\d{4})?$/;

    // If the value of the control tests against the regex, there is no error (return null).
    return c.value == null || c.value == '' || ZIP_REGEX.test(c.value)
        ? null
        : {
            validateZipCode: {
                valid: false,
            },
        };
}
